<template>
  <MenuComponent
    :custom_title="$t('Menu.Automation')">
    <template #navbar>
      <NavBar
        :active="activeMenyIndex"
        :create_router_to="{name: 'addAutomation', params: {org: $route.params.org} }"
        :create_text="$t('Automation.CreateRule')"
        :items="automationItems"
        :loading="loading"
        :types="menuTypes"
        unload
        @filterItems="choeseType"/>
    </template>
    <template #filter>
      <SearchInput
        debounce
        :search.sync="search"
        width="200px"/>
    </template>
    <template #items>
      <sAlert
        v-if="isTesterOrgs"
        type="warning">
        {{ $t('Common.WarningTitle') }}
        <template slot="desc">
          {{ $t('Common.orgToTesting') }}
        </template>
      </sAlert>
      <transition-group>
        <EmptyBlock
          v-if="!loading && filtredFields.length == 0"
          key="empty-block"
          :text="search ? $t('Tenders.CategoryNotFound') : $t('Tenders.NoData')"/>
        <transition-group
          v-else
          key="exists-block"
          class="pt-4"
          name="s-zoom-in-center"
          tag="div">
          <AutomationCard
            v-for="(automaticonItem, n) in filtredFields"
            :key="automaticonItem.id + '' + n"
            :class="{'mb-5': n != (filtredFields.length - 1)}"
            :disabled="loading"
            :item="automaticonItem"
            :spr="{additionalFields: $_additionalFields}"
            @delete="deleteItem"/>
        </transition-group>
      </transition-group>
    </template>
  </MenuComponent>
</template>
<script>
//import InfinityUpdater from 'components/extends/InfinityUpdater.vue'
import NavBar from 'components/common/blocks/NavBar.vue'
import MenuComponent from 'pages/templates/MenuComponent.vue'
import EmptyBlock from 'components/common/elements/EmptyBlock.vue'
import SearchInput from 'components/common/inputs/SearchInput.vue'
//import ModeButtons from 'components/common/elements/ModeButtons.vue'
import AutomationCard from 'components/automation/AutomationCard.vue'

import { storageMixin } from 'mixins'
import { mapGetters } from 'vuex'
import automations from 'mixins/automations'
import textFunctions from 'mixins/textFunctions'

import AutomationsApi from '@/api/automationsApi'
const automations_api = new AutomationsApi()

export default {
  name: 'automationsPage',
  mixins: [ storageMixin, automations, textFunctions ],
  data() {
    return {
      activeMenyIndex: 0,
      automationItems: [],
      loading: true,
      search: '',
      tableMode: false,
      menuTypes: [
        {
          name: this.$t('Purchasing.All'),
          type: 'all'
        },
      ],
      filterByType: null
    }
  },
  methods: {
    choeseType(type) {
      if (!type) {
        return
      }
      const typeIndex = this.menuTypes.findIndex(i => i.type === type.type)
      if (typeIndex !== -1 && typeIndex !== this.activeMenyIndex) {
        this.$_savePropToDBStorage('automationPage_menuType', type.type)
        this.activeMenyIndex = typeIndex
        this.filterByType = type.filter
      }
    },
    deleteItem(itemId) {
      this.loading = true
      automations_api.api_deleteAutomation({automationId: itemId})
        .then(result => {
          if (result) {
            var index = this.automationItems.findIndex(item => item.id === itemId)
            if (index !== -1) {
              this.automationItems.splice(index, 1)
            }
          } else {
            this.$notice.warning({
              title: this.$t('Common.ErrorTitle'),
              message: this.$t('Errors.STHWrong'),
              dangerouslyUseHTMLString: true,
              duration: 10
            })
          }
        })
        .finally(() => {
          this.loading = false
        })
        .catch(error => {
          this.$log_error(error.message)
          this.$notice.error({
            title: this.$t('Common.ErrorTitle'),
            message: error?.message || this.$t('Errors.STHWrong'),
            duration: 10,
          })
        })
    },
    async getAutomationsData() {
      this.loading = true
      await automations_api.api_getAutomations()
        .then(res => {
          this.automationItems = res
        })
        .finally(() => {
          this.createMenu()
          this.loading = false
        })
    },
    createMenu() {
      const result = [
        {
          name: this.$t('Purchasing.All'),
          type: 'all',
          count: this.automationItems?.length
        }
      ]
      this.mixin_spr.triggers.forEach(trigger => {
        const triggerType = this.$_convertToUpperCaseWithUnderscore(trigger)

        result.push({
          name: this.$t(`Automation.trigger.${trigger}`),
          class: 'pl-7',
          type: trigger,
          filter: el => {
            return el.trigger.triggerType === triggerType
          },
        })
      })
      result.push(
        {
          name: this.$tc('Automation.Active', 1),
          type: 'active',
          count: this.automationItems?.filter(i => i.isActive)?.length,
          filter: el => {
            return el.isActive
          },
        },
        {
          name: this.$t('Automation.notActive'),
          type: 'notActive',
          count: this.automationItems?.filter(i => !i.isActive)?.length,
          filter: el => {
            return !el.isActive
          },
        },
      )
      this.menuTypes = result

    },
    async initial() {
      await this.$_getAdditionalFields()
      await this.getAutomationsData()
      await this.$_getPropFromDBStorage('automationPage_menuType', 0)
        .then(async (menuType) => {
          const index = this.menuTypes.findIndex(i => i.type == menuType)
          if (index !== -1) {
            this.choeseType(this.menuTypes[index])
          }
        })
    }
  },
  computed: {
    ...mapGetters({
      currentOrganization: 'getCurrentOrganization',
    }),
    filtredFields() {
      /*return [
        {
          id: 'test',
          name: 'name',
        }
      ]*/
      if (!this.filterByType && !this.search) {
        return this.automationItems || []
      }

      return this.automationItems?.filter(field => {
        let resultSearch = this.search ? field.title?.toLowerCase().includes(this.search.toLowerCase()) : true
        let resultFilterByType = this.filterByType ? this.filterByType(field) : true

        return resultSearch && resultFilterByType
      }) || []
    }
  },
  watch: {
    'currentOrganization.organizationItId': {
      immediate: true,
      deep: true,
      handler(newValue, oldValue) {
        if (!oldValue || newValue !== oldValue) {
          this.initial()
        }
      }
    }
  },
  created() {
    if (!this.$_accessAutomations) {
      this.$router.push({name: 'page-error', params: { status_code: '403', descript: 'Нет доступа к automations page' } })
    }
  },
  components: {
    NavBar,
    EmptyBlock,
    SearchInput,
    //ModeButtons,
    MenuComponent,
    AutomationCard
    //InfinityUpdater
  }
}
</script>
<style scoped lang="scss">
.emergency-page {
  background: var(--color-main-green);
}
</style>
